import React from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

const buttonStyles = css`
  display: inline-block;
  padding: ${props => props.size === 'large'
    ? `${props.theme.spacing.md} ${props.theme.spacing.xl}`
    : props.size === 'small'
      ? `${props.theme.spacing.xs} ${props.theme.spacing.md}`
      : `${props.theme.spacing.sm} ${props.theme.spacing.lg}`};
  border-radius: ${props => props.theme.borderRadius.medium};
  font-weight: 600;
  text-align: center;
  transition: all ${props => props.theme.transitions.fast};
  cursor: pointer;
  border: 2px solid transparent;


  ${props => {
    if (props.variant === 'primary') {
      return css`
        background-color: ${props.theme.colors.primary};
        color: white;

        &:hover {
          background-color: transparent;
          border-color: ${props.theme.colors.primary};
          color: white;
        }
      `;
    } else if (props.variant === 'secondary') {
      return css`
        background-color: ${props.theme.colors.primary};
        color: white;

        &:hover {
          background-color: transparent;
          border-color: ${props.theme.colors.primary};
          color: ${props.theme.colors.primary};
        }
      `;
    } else if (props.variant === 'outline') {
      return css`
        background-color: transparent;
        border-color: ${props.theme.colors.primary};
        color: ${props.theme.colors.primary};

        &:hover {
          background-color: ${props.theme.colors.primary};
          color: white;
        }
      `;
    }
  }}

  ${props => props.fullWidth && css`
    width: 100%;
  `}
`;

const StyledButton = styled.button`
  ${buttonStyles}
`;

const StyledLink = styled(Link)`
  ${buttonStyles}
`;

const StyledExternalLink = styled.a`
  ${buttonStyles}
`;

const Button = ({
  children,
  variant = 'primary',
  size = 'medium',
  to,
  href,
  fullWidth = false,
  ...props
}) => {
  if (to) {
    return (
      <StyledLink
        to={to}
        variant={variant}
        size={size}
        fullWidth={fullWidth}
        {...props}
      >
        {children}
      </StyledLink>
    );
  } else if (href) {
    return (
      <StyledExternalLink
        href={href}
        variant={variant}
        size={size}
        fullWidth={fullWidth}
        target="_blank"
        rel="noopener noreferrer"
        {...props}
      >
        {children}
      </StyledExternalLink>
    );
  }

  return (
    <StyledButton
      variant={variant}
      size={size}
      fullWidth={fullWidth}
      {...props}
    >
      {children}
    </StyledButton>
  );
};


export const PrimaryButton = styled.button`
  display: block;
  padding: 0.8rem;
  background-color: ${props => props.featured ? props.theme.colors.primary : 'white'};
  color: ${props => props.featured ? 'white' : props.theme.colors.primary};
  border: 2px solid ${props => props.theme.colors.primary};
  border-radius: ${props => props.theme.borderRadius.small};
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${props => props.theme.colors.primary};
    color: white;
  }
`;


export default Button;